import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ConfigProvider } from '@mydocma/common';
import { TASK_CONFIG, TaskConfig, WEBSOCKET_CONFIG, WebsocketConfig } from '@mydocma/task';
import { AuthSettings, AUTHSETTINGS, AUTHSTORAGE } from '@mydocma/auth';
import { APP_CONTAINER_SETTINGS, AppContainerSettings } from '@mydocma/app-container';
import { MydocmaSettings, MYDOCMASETTINGS } from '@mydocma/core';
import { BP_CONFIG, BpConfig } from 'projects/mydocma/co/src/lib/common/config/bp.config';
import { BP_CONFIG as BP_CONFIG_DIST } from '@mydocma/co/src/lib/common';

interface AppConfig {
  appName: string,
  taskConfig: TaskConfig,
  webSocketConfig: WebsocketConfig,
  authConfig: AuthSettings,
  mydocmaConfig: MydocmaSettings,
  appContainerConfig: AppContainerSettings,
  bpConfig: BpConfig
}


if (environment.production) {
  enableProdMode();
}

async function main() {

  try {
    const configProvider = new ConfigProvider<AppConfig>(null);
    const config = await configProvider.loadConfigAsync();

    await platformBrowserDynamic([
    //we could do it here or in app-module

    { provide: TASK_CONFIG, useValue: config.taskConfig },
    { provide: WEBSOCKET_CONFIG, useValue: config.webSocketConfig },
    { provide: AUTHSETTINGS, useValue: config.authConfig },
    { provide: AUTHSTORAGE, useValue: sessionStorage },
    { provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig },
    { provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig },
    { provide: BP_CONFIG, useValue: {...config.bpConfig, parentApp: config.appName}},
    { provide: BP_CONFIG_DIST, useValue: {...config.bpConfig, parentApp: config.appName}},



    ]).bootstrapModule(AppModule).then(() => {
      /*if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('ngsw-worker.js');
      }*/
    })
  } catch (error) {
    console.error(error);
  }
}

main()
